import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import AppHead from '@/Shared/AppHead'

InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,
    color: '#433edb',
})

window.Vapor = require('laravel-vapor')
window.Tabby  = require('tabbyjs')

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin, VuePluralize }) {
        createApp({ render: () => h(App, props) })
        .use(plugin)
        .mixin({
            methods: {
                asset: window.Vapor.asset,
                route: window.route,
                formatTime: function(d) {
                    d = Number(d)
                    var h = Math.floor(d / 3600)
                    var m = Math.floor(d % 3600 / 60)
                    var s = Math.floor(d % 3600 % 60)
                    var mDisplay = '0:'
                    var sDisplay = '00'
                    var hDisplay = h > 0 ? h + ':' : ''

                    if (m > 0) {
                        mDisplay = m + ':'
                        if (h > 0) {
                            mDisplay = m < 10 ? '0' + m + ':' : m + ':'
                        }
                    }
                    if (s > 0) {
                        sDisplay = s < 10 ? '0' + s : s
                    }

                    return hDisplay + mDisplay + sDisplay
                },
            }
        })
    .component('Head', Head)
    .component('Link', Link)
    .component('AppHead', AppHead)
    .mount(el)
},
})
